import { css } from 'lit';

import token from '../../utils/get-token';

export function styles() {
	return css`
		:host {
			display: flex;
			justify-content: flex-end;
			gap: ${token('spacing-2')};
		}
	`;
}
